import React from "react";
export function Signature() {
  return (
    <footer className="site-footer">
      <div>
        <strong>RAFFLER</strong>
        <span>
          An affectionate parody in honor of{" "}
          <a href="https://www.rappler.com/" target="_blank" rel="noreferrer">
            Rappler
          </a>
          . Independently made; unaffiliated.
        </span>
      </div>
      <a
        href="https://github.com/alwinpamintuan/"
        target="_blank"
        rel="noreferrer"
      >
        Made by Alwin Pamintuan ↗
      </a>
    </footer>
  );
}
